import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import addErrors from 'action-creators/account/add-errors';
import _dismissError from 'action-creators/account/dismiss-error';

const propTypes = {
  errors: PropTypes.instanceOf(Map).isRequired,
  setErrors: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    dismissError: _dismissError,
    setErrors: addErrors,
  }, dispatch)
);

const mapStateToProps = state => ({
  errors: state.account.errors,
});

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function withErrors(WrappedComponent) {
  const ErrorWrapper = ({
    errors,
    setErrors,
    dismissError,
    ...rest
  }) => (
    <WrappedComponent
      errors={errors}
      setErrors={setErrors}
      dismissError={dismissError}
      {...rest}
    />
  );

  ErrorWrapper.displayName = `withErrors(${getDisplayName(WrappedComponent)})`;
  ErrorWrapper.propTypes = propTypes;
  return connect(mapStateToProps, mapDispatchToProps)(ErrorWrapper);
}
